import React, { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { USER_URL } from '../api_base.js';
import { buildHeaders } from '../utils/apiHeaders.js';

// Same server-truth pattern as AuthGuard (the token is httpOnly, so we can't
// check it client-side), but also checks the role that comes back from
// GET /users and blocks anyone not in `allowedRoles`.
const RoleGuard = ({ allowedRoles = ["admin", "viewer"] }) => {
    const [status, setStatus] = useState("checking"); // checking | allowed | guest | forbidden
    const [role, setRole] = useState(null);

    const location = useLocation();

    useEffect(() => {
        let cancelled = false;

        const checkAuth = async () => {
            try {
                const res = await fetch(USER_URL + "/users", {
                    method: "GET",
                    credentials: "include",
                    headers: buildHeaders(),
                });
                const data = await res.json();

                if (cancelled) return;

                if (!res.ok) {
                    setStatus("guest");
                    return;
                }

                setRole(data.data?.role);
                setStatus(allowedRoles.includes(data.data?.role) ? "allowed" : "forbidden");
            } catch (err) {
                if (!cancelled) setStatus("guest");
            }
        }

        checkAuth();
        return () => { cancelled = true; }
    }, []);

    if (status === "checking") {
        return (
            <div className="status_page">
                <span className="loading"></span>
            </div>
        )
    }

    if (status === "guest") {
        return <Navigate to="/auth" replace state={{ from: location }} />
    }

    if (status === "forbidden") {
        return <Navigate to="/unauthorized" replace />
    }

    return <Outlet context={{ role }} />
}

export default RoleGuard;
